export default "__VITE_ASSET__eI_2jRPm__"